import type { StudyTaskTargetEngagementSelectDto } from '@@types/api.types';
import { Badge } from '@components/ui/badge';
import type { FC } from 'react';
import { formatPkEstimate, getEngagementTypeLabel, getPkBandBadgeVariant } from './meia-p3-engagement.util';

type MeiaTaskEngagementPillsProps = {
  engagements: StudyTaskTargetEngagementSelectDto[];
  limit?: number;
};

/** Compact RED-target pills shown on P3 task cards; authoring lives in the task modal's Red Target Engagement step. */
export const MeiaTaskEngagementPills: FC<MeiaTaskEngagementPillsProps> = (props) => {
  const { engagements, limit = 3 } = props;
  const visibleEngagements = engagements.slice(0, limit);
  const hiddenCount = Math.max(0, engagements.length - visibleEngagements.length);

  if (engagements.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {visibleEngagements.map((engagement) => (
        <span
          className="inline-flex max-w-full items-center gap-1 rounded-sm bg-rose-50 px-1.5 py-0.5 text-[10px] font-medium text-rose-700"
          key={engagement.id}
        >
          <span className="truncate">RED {engagement.threatTargetSystemCode}</span>
          {engagement.engagementType && <span>{getEngagementTypeLabel(engagement.engagementType)}</span>}
          <Badge
            size="xs"
            variant={getPkBandBadgeVariant(engagement.pkEstimate)}
          >
            {formatPkEstimate(engagement.pkEstimate)}
          </Badge>
        </span>
      ))}
      {hiddenCount > 0 && (
        <span className="rounded-sm bg-gray-100 px-1.5 py-0.5 text-[10px] font-medium text-gray-700">
          +{hiddenCount} targets
        </span>
      )}
    </div>
  );
};
